import { useAuth0 } from '@auth0/auth0-react';

import { Button } from '@progress/kendo-react-buttons';

export function SignIn() {
  const mailto = 'mailto:support@accelerationpoint.com?subject=Kwello Support Request';
  const { loginWithRedirect } = useAuth0();

  const onClick = () => {
    loginWithRedirect().catch((err) => console.error(err));
  };

  return (
    <div className="sign-in">
      <h1>Sign in</h1>
      <div className="bottom-margin soft-desktop-gray-700">
        Enter your organisation's email address to sign in. You will be redirected to a single sign
        on authentication page
      </div>
      <div className="sign-in-button">
        <Button themeColor={'secondary'} onClick={onClick} size="large">
          Sign in to Kwello
        </Button>
      </div>
      <div
        className="help body-soft-desktop-blue-500"
        onClick={(e) => {
          window.location.href = mailto;
          e.preventDefault();
        }}
      >
        Get help signing in
      </div>
    </div>
  );
}
